import React, { useState } from "react";
import { toast } from "react-toastify";
import { AddAmendmentApi } from "../../../../Api/Operations/WorkOrders";
import ActionButton from "../../../Common/ActionButton";

export default function AddAmendmentModal({ isOpen, onClose, woData, onSuccess }) {
  const [reason, setReason] = useState("");
  const [amendedAmount, setAmendedAmount] = useState("");
  const [submitting, setSubmitting] = useState(false);

  if (!isOpen) {
    return null;
  }

  const validate = () => {
    if (!reason || reason.trim() === "") {
      toast.info("Reason is required");
      return false;
    }
    if (!amendedAmount || Number(amendedAmount) <= 0) {
      toast.info("Amended amount is required and must be greater than 0");
      return false;
    }
    return true;
  };

  const handleSubmit = async () => {
    if (!validate()) {
      return;
    }
    setSubmitting(true);
    try {
      const payload = {
        workOrderId: woData?.Id,
        reason: reason.trim(),
        amendedAmount: Number(amendedAmount),
      };

      const res = await AddAmendmentApi(payload);
      const json = res?.data || res;
      if (json?.IsSuccess) {
        toast.success(json.Message || "Amendment added successfully");
        setReason("");
        setAmendedAmount("");
        onSuccess?.();
      } else {
        toast.error(json?.Message || "Failed to add amendment");
      }
    } catch (err) {
      console.error(err);
      toast.error("Error adding amendment");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="modalscreen" style={{ display: "block", height: "100vh", overflow: "auto" }}>
      <div className="modal-content-screen1">
        <div className="row sticky-topNew">
          <div className="col-12 page_heading">
            <h4 className="text-center mb-0">Add Amendment</h4>
            <span className="close pr-2" onClick={onClose}>
              &times;
            </span>
          </div>
        </div>

        <div className="pl-3 pr-3">
          <div className="row">
            <div className="col-md-2 mt-md-4 text-left p-0">
              <label className="input_label m-0">Amended Amount:</label>
            </div>
            <div className="col-md-3 mt-md-4 p-0 d-flex">
              <input
                type="number"
                className="input_styling ml-md-3"
                min={0}
                value={amendedAmount}
                onChange={(e) => setAmendedAmount(e.target.value)}
                placeholder="Enter amount"
              />
              <span className="estaric">*</span>
            </div>
            <div className="col-md-2 mt-md-4 text-left p-0"></div>
          </div>

          <div className="row">
            <div className="col-md-2 mt-md-4 text-left p-0">
              <label className="input_label m-0">Reason:</label>
            </div>
            <div className="col-md-3 mt-md-4 p-0 d-flex">
              <textarea
                className="input_address ml-md-3"
                rows={4}
                value={reason}
                onChange={(e) => setReason(e.target.value)}
                placeholder="Enter reason for amendment"
              />
              <span className="estaric">*</span>
            </div>
          </div>

          <div className="row mt-4">
            <div className="col-12 d-flex justify-content-end" style={{ gap: 8 }}>
              <ActionButton
                text="Cancel"
                variant="cancel"
                onClick={onClose}
                disabled={submitting}
              />
              <ActionButton
                text={submitting ? "Please wait..." : "Add Amendment"}
                variant="save"
                onClick={handleSubmit}
                disabled={submitting}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
